<div class="px-4" [class]="direction">
  <div class="flex justify-between items-center">
    <h3 class="text-base">{{ favoriteRoutesText }}</h3>
    <mot-button
      (onClick)="openEditFavoritesMenu()"
      textClass="text-sm"
      buttonClass="!bg-transparent"
      [text]="editText"
      ariaHaspopup="dialog"
      />
    </div>

    @if (
      !!favoriteRoutes && !!favoriteRoutes?.length) {
      <ul class="flex flex-col list-none p-0 pb-32 gap-2">
        @for (routeData of favoriteRoutes; track routeData; let i = $index) {
          <div class="flex justify-between items-center">
            <li class="w-full">
              <button
                type="button"
                class="w-full cursor-pointer border-0 bg-transparent p-0 text-left font-inherit"
                (click)="onFavoriteRouteClick.emit(routeData)"
                >
                <app-favorite-route [route]="routeData" />
              </button>
            </li>
            <!-- <mot-button
            *ngIf="routeData.route?.specialMessages?.routeMessages?.length || routeData.route?.specialMessages?.stopMessages?.length"
            type="icon"
            icon="message-exclamation-new message"
            buttonClass="!bg-transparent"
            [iconClass]="'text-2xl'"
            (onClick)="openSpecialMessages(routeData.route)"
            /> -->
          </div>
          <mat-divider class="bg-gray-600" />
        }
      </ul>
    } @else {
      <div class="flex gap-2 items-center w-full" [class]="direction" aria-hidden="true">
        <img
          src="assets/images/route-planning/source-destination/route_empty_state.svg"
          alt=""
          />
        <div class="flex flex-col gap-[0.125rem]">
          <span class="text-[#3D5979] font-normal text-sm">{{ didntAddFavoriteRoutesTextPart1 }}</span>
          <span class="text-[#3D5979] font-normal text-sm">{{ didntAddFavoriteRoutesTextPart2 }}</span>
        </div>
      </div>
    }


    </div>
